module.exports = __webpack_public_path__ + "static/GOYM-5017d31b42a617aaef8c65d9f965e7c3.jpg";